<script lang="ts">
    import { onDestroy, onMount } from "svelte";

    import { fade } from "svelte/transition";

    export let onClick: (event: Event) => void;
    export let center: boolean = true;

    let containerElement: HTMLDivElement;

    function onOverlayClick(event: Event) {
        if (event.target === containerElement) {
            onClick(event);
        }
    }

    function onKeydown(event: KeyboardEvent) {
        if (event.key === "Escape") {
            onClick(event);
        }
    }
    onMount(async () => {
        document.body.classList.add("noscroll");
    });
    onDestroy(async () => {
        document.body.classList.remove("noscroll");
    });
</script>

<svelte:window on:keydown={onKeydown} />

<div
    class="fixed inset-0 bg-gray-900 bg-opacity-75 flex z-50 overflow-y-scroll"
    class:items-center={center}
    class:justify-center={center}
    transition:fade={{ duration: 300 }}
    on:click={onOverlayClick}
    bind:this={containerElement}>
    <slot />
</div>
